import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { BaseComponent } from '../shared/base.component';
import { AppService } from '../app.service';
import { BaseService } from '../shared/base.service';
import { HomeService } from './home.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { UsersService } from '../users/users.service';

@Component({
    selector: 'home-component',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    providers: [
        BaseService, HomeService, UsersService
    ]
})

export class HomeComponent extends BaseComponent implements OnInit {
    user: object[];
    roleId: number;

    readonly MIN_NO_OF_NOTIFICATIONS = 4;
    readonly MAX_NO_OF_NOTIFICATIONS = 10;
    readonly filterSearchChars = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;

    /**
     * Handle content when the notification tab is empty
     * @type {string}
     */
    emptyNotificationMessages: any;
    searchInListTranslation: string = 'Search in list';

    constructor(public authService: AuthService,
                public router: Router,
                public translate: TranslateService,
                public baseService: BaseService,
                public appService: AppService,
                public usersService : UsersService
            ) {

        super(authService, router, baseService, appService);

        this.user = this.authService.user;
        this.roleId = this.user['role_id'];

        this.emptyNotificationMessages = {
            'userTab': 'You have no new user notification.',
            'clinicTab': 'You have no new clinic notification.'
        };

        this.translate.get('Search in list').subscribe((res: string) => {
            this.searchInListTranslation = res;
        });
    }

    ngOnInit() {
        window.scrollTo(window.scrollX, 0);
        this.appService.removePatientsFilter();

        this.searchResults = Observable.create((observer: any) => {
            if (this.searchInfo.keyword.match(this.filterSearchChars)) {
                this.searchInfo.keyword = this.searchInfo.keyword.replace(this.filterSearchChars, '');
            }

            if (this.searchInfo.keyword !== '') {
                this.usersService.search(this.searchInfo.keyword, this.searchInfo.role_id, this.searchInfo.clinic_id)
                    .subscribe((result: any) => {
                        observer.next(result);
                    });
            }
        });

        // Navigate b2c patient to b2c UI
        if (this.authService.user.is_b2c && this.authService.user.patient_id) {
            this.appService.isLoading = true;
            this.appService.callApiGetClinicConfig(this.authService.user.clinic_id).subscribe(res => {
                this.appService.storeMeClinicFolder(res);
                this.appService.isLoading = false;
                this.router.navigate(['/me/dashboard']);
            });
        }
    }

    /**
     * Open and redirect notification
     * @param notification
     */
    openNotification(notification: any) {
        this.removeNotification(notification);

        if (notification.data.params.redirect_url) {
            this.router.navigateByUrl(notification.data.params.redirect_url);
        }
    }

    /**
     * Remove notification
     * @param notification
     */
    removeNotification(notification: any) {
        this.appService.markNotificationAsRead(notification.id);
    }

    /**
     * Set search data result
     * @param data
     */
     setData(data: any): void {
        this.items = data.items;
        this.filters = {key: ''};
        this.totalItems = data.total;

        // if users are empty, hide the page numbers below the users list to prevent page redirection
        if (this.items.length === 0) {
            this.paginationHidden = true;
        } else {
            this.paginationHidden = false;
        }

        this.isLoading = false;
    }

    /**
     * Search
     */
    searchItems(): void {
        this.router.navigate(['/users'], {
            queryParams: {
                filters: 'keyword-' + this.searchInfo.keyword
            }
        });
    }

}
